import React, { SVGProps } from 'react'
const SvgNavAlertCircle = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={8}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <rect
      width={7}
      height={7}
      x={0.5}
      y={0.5}
      fill="#FAD3D6"
      stroke="#D5404A"
      rx={3.5}
    />
  </svg>
)
export default SvgNavAlertCircle
